import { createActionGroup, emptyProps } from "@ngrx/store";

export const SetupActions = createActionGroup({
	source: "Setup Page",
	events: {
		"Get Latest App Version": emptyProps(),
	},
});
